import BreadcrumbSimple from "../../components/BreadcrumbSimple/index.jsx";
import React from "react";
import { toast } from "react-toastify";
import chainData from "../../chains.js";

/**
 * MetaModal — NFT metadata attributes modal content.
 *
 * Rendered as the `content` slot of Modal2. Displays trait types/values
 * (clickable to search), external links, and navigation to item detail page.
 *
 * @param item - NFT item with meta, coll, tokId, etc.
 * @param setMC - Setter for modal content
 * @param fbItem - Unused legacy fallback item ID
 * @param showModal - Function to show/hide modal
 * @param doSearch - Search function for trait value clicks
 * @param history - Navigation function
 * @param chainIndex - Network index for chainSlug
 * @param noMeta - Show "no traits" message if true
 */
const MetaModal = async ({ item, setMC, fbItem, showModal, doSearch, history, chainIndex, noMeta, imgUrl }) => {
  let myJson = item?.meta;

  const chainSlug = chainIndex !== undefined
    ? (chainData[chainIndex]?.tokName?.toLowerCase() || 'sgb')
    : 'sgb';

  setMC(
    <>
      {imgUrl && (
        <div style={{ position: 'relative', marginBottom: '12px', borderRadius: 'var(--card-radius, 12px)', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.06)' }}>
          <img
            src={imgUrl}
            alt={item?.meta?.name || 'NFT'}
            style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'contain', objectPosition: 'center', maxHeight: 'calc(85vh - 140px)' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, transform: 'translateY(-50%)', padding: '12px', background: 'linear-gradient(transparent, rgba(12,16,32,0.95))' }}>
            {/*<div style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '12px', color: '#fff', WebkitTextStroke: '2px #000', textShadow: '2px 0 0 #000, -2px 0 0 #000, 0 2px 0 #000, 0 -2px 0 #000, 2px 2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, -2px -2px 0 #000' }}>
              {item?.meta?.name || 'Token Metadata'}
            </div>*/}
            <div style={{ maxHeight: 'calc(85vh - 280px)', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', padding: '4px', lineHeight: 1.25 }}>
              {noMeta ? (
                <div style={{ textAlign: 'center', color: '#aeb6c8', padding: '16px 0' }}>
                  This item has no traits defined, or we don't have a record of them. Click "go to item page" and we will attempt to fetch them.
                </div>
              ) : (
                myJson?.attributes?.map((_item, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                    <span className="text-meta-border">{_item.trait_type}</span>
                    <span className="text-meta-border">
                      {_item?.value?.toString()?.includes("://") ? (
                        <a rel="noopener noreferrer" href={_item.value} target="_blank" style={{ color: 'rgba(255,255,255,0.88)', textDecoration: 'none' }}>{_item.value}</a>
                      ) : (
                        <span style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.88)' }} onClick={() => { const search = document.getElementById("someid"); if (search) search.value = _item.value; doSearch(); }}>{_item.value}</span>
                      )}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}

      <div style={{ textAlign: 'center', margin: '12px 0', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {myJson?.external_url && (
          <a href={myJson.external_url} style={{ color: 'rgba(255,255,255,0.88)', textDecoration: 'underline', fontSize: '0.9rem' }}>Website</a>
        )}
        {myJson?.youtube_url && (
          <a href={myJson.youtube_url} style={{ color: 'rgba(255,255,255,0.88)', textDecoration: 'underline', fontSize: '0.9rem' }}>YouTube</a>
        )}
        {myJson?.animation_url && (
          <a href={myJson.animation_url} style={{ color: 'rgba(255,255,255,0.88)', textDecoration: 'underline', fontSize: '0.9rem' }}>Media</a>
        )}
      </div>

      <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <button
          className="pixel-btn"
          style={{ width: '100%' }}
          onClick={() => {
            showModal(false);
            const path = item?.meta?.edition
              ? `/item/${chainSlug}/${item.coll}/${item?.meta?.edition}`
              : `/item/${chainSlug}/${item.coll}/${item?.tokId}`;
            history({ to: path });
          }}
        >
          Go To Item Page
        </button>
        <button
          className="pixel-btn"
          style={{ width: '100%', background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', color: '#aeb6c8' }}
          onClick={() => showModal(false)}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default MetaModal;
